import httpClient from "../httpClient";
import { API_GROUP_CREATE } from "../config";

const createGroup = {
    create: (data) => httpClient.post(API_GROUP_CREATE, data),
};

export default createGroup;